import { render, staticRenderFns } from "./DeclineActionMenu.vue?vue&type=template&id=f87ea0ee"
import script from "./DeclineActionMenu.vue?vue&type=script&lang=js"
export * from "./DeclineActionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports